const zh = {
  nav: {
    home: '首页',
    categories: '赛事分类',
    articles: '体育资讯',
    about: '关于我们',
    download: 'APP下载',
  },
  home: {
    hero_title: '皇冠体育 · 官方正版体育竞猜平台',
    hero_subtitle: '覆盖足球、篮球、网球等全球顶级赛事，实时赔率、多端支持、极速存取款',
    hero_cta: '立即注册',
    hero_download: 'APP下载',
    matches_title: '热门赛事推荐',
    matches_subtitle: '精选全球顶级赛事，实时赔率更新',
    odds_home: '主胜',
    odds_draw: '平局',
    odds_away: '客胜',
    advantages_title: '为什么选择皇冠体育',
    advantages_subtitle: '五大核心优势，成就专业竞猜体验',
    adv_speed_title: '极速存取款',
    adv_speed_desc: '多种支付方式，资金秒到账，提现快至5分钟',
    adv_security_title: '安全稳定',
    adv_security_desc: '银行级加密技术，多重安全防护，资金保障无忧',
    adv_odds_title: '实时赔率',
    adv_odds_desc: '全球赛事赔率实时推送，把握最佳投注时机',
    adv_multi_title: '多端支持',
    adv_multi_desc: '网页版、APP、移动端全覆盖，随时随地畅享竞猜',
    adv_service_title: '7×24客服',
    adv_service_desc: '专业客服团队全天候在线，为您答疑解惑',
    news_title: '最新体育资讯',
    news_subtitle: '掌握最新赛事动态与竞猜技巧',
    read_more: '阅读全文',
    cta_title: '加入皇冠体育，开启您的竞猜之旅',
    cta_subtitle: '注册即享专属优惠，新用户首充即送礼金，立即体验顶级赛事竞猜',
    cta_button: '免费注册',
  },
  category: {
    title: '赛事分类',
    all: '全部赛事',
    football: '足球',
    basketball: '篮球',
    tennis: '网球',
    esports: '电竞',
    other: '其他赛事',
    live: '滚球',
    upcoming: '即将开始',
    today: '今日赛事',
    league: '联赛',
    time: '开赛时间',
    home_team: '主队',
    away_team: '客队',
    no_matches: '暂无赛事数据',
  },
  article: {
    list_title: '体育资讯',
    list_subtitle: '最新赛事动态与竞猜攻略',
    read_more: '阅读全文',
    back_to_list: '返回列表',
    prev_article: '上一篇',
    next_article: '下一篇',
    published: '发布时间',
    author: '作者',
    views: '阅读量',
    related: '相关文章',
  },
  about: {
    title: '关于皇冠体育',
    intro_title: '品牌介绍',
    intro_text1: '皇冠体育是业内领先的专业体育竞猜平台，自成立以来始终秉承"诚信为本、用户至上"的经营理念，致力于为广大体育爱好者提供安全、公平、专业的竞猜服务。',
    intro_text2: '平台覆盖足球、篮球、网球、电竞等全球顶级赛事，拥有专业的赔率分析团队和稳定的技术平台，为用户提供实时赔率更新、多端无缝切换、极速资金流转等优质体验。',
    intro_text3: '皇冠体育已获得多项国际权威认证，采用银行级数据加密技术，确保用户信息和资金安全。我们始终坚持合规经营，为用户打造值得信赖的体育娱乐平台。',
    reputation_title: '信誉与资质',
    rep_license: '合法牌照',
    rep_license_desc: '持有国际合法博彩运营牌照，受权威机构监管',
    rep_security: '资金安全',
    rep_security_desc: '第三方资金托管，多重加密防护，用户资金独立存放',
    rep_fair: '公平公正',
    rep_fair_desc: '所有赛事结果公开透明，赔率计算独立第三方审计',
    rep_privacy: '隐私保护',
    rep_privacy_desc: '严格遵守国际隐私法规，用户数据绝不外泄',
    contact_title: '联系我们',
    contact_email: '客服邮箱',
    contact_phone: '客服热线',
    contact_hours: '服务时间',
    contact_address: '公司地址',
    faq_title: '常见问题',
  },
  footer: {
    about: '关于皇冠体育',
    links: '快速链接',
    support: '客户支持',
    copyright: '© 2026 皇冠体育 huangguan-sports.com 版权所有',
    disclaimer: '理性投注，量力而行。未满18周岁者禁止参与竞猜。',
    privacy: '隐私政策',
    terms: '服务条款',
    responsible: '责任博彩',
  },
  breadcrumb: {
    home: '首页',
  },
  seo: {
    home_title: '皇冠体育 - 官方正版体育竞猜平台 | 足球篮球网球实时赔率',
    home_desc: '皇冠体育是业内领先的专业体育竞猜平台，覆盖足球、篮球、网球等全球顶级赛事。提供实时赔率、多端支持、极速存取款，安全稳定，注册即享专属优惠。',
    home_keywords: '皇冠体育,皇冠体育官网,皇冠体育投注,皇冠体育app下载,皇冠体育赔率,皇冠体育注册,皇冠体育足球竞猜',
    category_title: '赛事分类 - 皇冠体育',
    category_desc: '皇冠体育提供足球、篮球、网球、电竞等全球顶级赛事竞猜，实时赔率更新，多端支持，为您带来专业体育竞猜体验。',
    category_keywords: '皇冠体育赛事,足球竞猜,篮球竞猜,网球竞猜,电竞竞猜,体育赔率',
    article_list_title: '体育资讯 - 皇冠体育',
    article_list_desc: '皇冠体育资讯频道，提供最新赛事动态、竞猜攻略、赛前分析等专业体育内容，助您把握每一场精彩赛事。',
    article_list_keywords: '皇冠体育资讯,赛事分析,竞猜攻略,体育新闻,足球资讯,篮球资讯',
    about_title: '关于皇冠体育 - 品牌介绍与联系方式',
    about_desc: '了解皇冠体育品牌故事、信誉资质与联系方式。皇冠体育是业内领先的专业体育竞猜平台，持有合法运营牌照，为您提供安全可靠的竞猜服务。',
    about_keywords: '皇冠体育,皇冠体育官网,皇冠体育介绍,皇冠体育联系方式,体育竞猜平台',
  },
};

export default zh;